/**
 * © 2025 Little Shilling, Inc.
 * Shon Little
 * Created: 2025-08-05
 */

// Add third-party dependencies.
import { Container, Paper, Box } from '@mui/material';

// Add local dependencies.
import PasswordResetRequestForm from './PasswordResetRequestForm';

/**
 * Password reset request page component.
 * @example
 * return <PasswordReset />
 * @returns {React.ReactElement} The password reset request page component.
 */
const PasswordReset: React.FC = () => (
  <Container component="main" maxWidth="sm">
    <Box
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
        <PasswordResetRequestForm />
      </Paper>
    </Box>
  </Container>
);

export default PasswordReset;
